import { Row } from '@tanstack/react-table';
import { Tables } from '@typings';

import { getExpanderRowId } from '../helpers';
import styles from '../Table.module.scss';

import { TableRow } from './TableRow';

interface Props<T> {
  parentRow: Row<T>;
  variant?: Tables.Variant;
}

export const ExpandedRow = <T,>({ children, parentRow, variant = 'white' }: React.WithChildren<Props<T>>) => {
  return (
    <TableRow isExpandedRow variant={variant}>
      <td id={getExpanderRowId(parentRow.id)} colSpan={parentRow.getVisibleCells().length} className={styles.expandedCell}>
        {children}
      </td>
    </TableRow>
  );
};
